// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__8v1O-","spin":"Loading_spin__ED2wb"};